import { isOS } from 'utils/device';

import { useEventListener } from '../useEventListener';

const PLATFORM = 'windows';
const PRINT_SCREEN_KEY = 'PrintScreen';
const WINDOWS_SHIFT_S = 'Windows + Shift + s';

/**
 * This hook will trigger the onScreenshot callback when a screenshot is taken
 * (Only on Windows)
 */
export const useOnScreenshot = (
  onScreenshot: ({ platform, command }: { platform: string; command: string }) => void,
) => {
  // Implementation from E1
  const onKeyup = (event: KeyboardEvent | Event) => {
    const e = event as KeyboardEvent;
    // Only tracking screenshot on Windows
    if (!isOS.WIN) return;

    let isScreenShot = false;
    let command = null;

    if (e.key === PRINT_SCREEN_KEY) {
      isScreenShot = true;
      command = PRINT_SCREEN_KEY;
    }

    // Windows + Shift + S (Windows) shortcut for taking a screenshot
    if (e.metaKey && e.shiftKey && e.key?.toLocaleLowerCase() === 's') {
      isScreenShot = true;
      command = WINDOWS_SHIFT_S;
    }

    if (isScreenShot && command) {
      onScreenshot({ platform: PLATFORM, command });
    }
  };

  useEventListener('keyup', onKeyup);
};
